<template>
  <v-row class="px-5">
    <v-col cols="6">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedDateFormatted"
            label="Date de début"
            outlined
            rounded
            hide-details
            append-icon="event"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>

        <v-date-picker
          locale="fr"
          v-model="start_date"
          :value="value.start_date"
          color="#6f52ed"
          header-color="#6f52ed"
        ><v-spacer></v-spacer>
            <v-btn
              text
              class="theme-btn glow"
              @click="menu = false"
            >
              Cancel
            </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="6">
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="computedDateFormatted2"
            label="Date de fin"
            outlined
            rounded
            hide-details
            append-icon="event"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          locale="fr"
          v-model="end_date"
          :value="value.end_date"
          @input="menu2 = false"
          color="#6f52ed"
          header-color="#6f52ed"
        ><v-spacer></v-spacer>
            <v-btn
              text
              class="theme-btn glow"
              @click="menu2 = false"
            >
              Cancel
            </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  created() {},

  data() {
    return {
      menu: false,
      menu2: false,
    };
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        };
      },
    },
  },
  computed: {
    computedDateFormatted() {
      // console.info('comp start', this.value.start_date);
      return this.formatDate(this.value.start_date);
    },
    computedDateFormatted2() {
      return this.formatDate(this.value.end_date);
    },
    start_date: {
      get() {
        return this.value.start_date;
      },
      set(val) {
        // console.info("insetter start", val);
        this.$emit("input", {
          start_date: val,
          end_date: this.value.end_date,
        });
      },
    },
    end_date: {
      get() {
        return this.value.end_date;
      },
      set(val) {
        // console.info("insetter end", val);
        this.$emit("input", {
          start_date: this.value.start_date,
          end_date: val,
        });
      },
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
  },
};
</script>

<style lang="scss">
</style>